import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemindersWidgetComponent } from './reminders-widget.component';



@NgModule({
  declarations: [
    RemindersWidgetComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    RemindersWidgetComponent,
  ],
})
export class RemindersWidgetModule { }
